<template>
  <LoadingDiv v-if="!isReady" />

  <template v-else>
    <div class="grey-bg-custom-x">
      <div class="container-x">
        <div class="row">
          <div class="col s12">

            <div class="section">
              <h5 class="header">
                Private & Social <b>Plan(s) </b>
                <span @click="next = !next">
                  <span class="btn-floating btn-large waves-effect waves-light" :class="{ red: !next, teal: next }"><i
                      class="material-icons" title="Add Scheme (New)">{{
                        next ? "cancel" : "add"
                      }}</i></span>
                </span>
              </h5>
            </div>

            <template v-if="!next">
              <PolicyEditDiv :policy="editPolicy" @complete="handleUpdateComplete" v-if="editPolicy" />

              <template v-else>
                <!-- Selected -->
                <div class="row plans-row">
                  <div class="col s12 m6" v-for="(plan, id) in plans" :key="plan.id">

                    <div class="card-panel grey lighten-5 z-depth-1">

                      <div class="row" :class="{ 'yellow lighten-2': plan.status == 's' }">

                        <div class="col s1">
                          <span class="chip">
                            {{ id + 1 }}
                          </span>
                        </div>

                        <div class="col s9">
                          <h5>{{ plan.name }}</h5>

                          <p>
                            <span class="chip" :class="{
                              'teal lighten-4': schemeType(plan) === 'p',
                              'orange lighten-4': schemeType(plan) === 's'
                            }">
                              {{ plan.description }}
                            </span>
                          </p>

                          <h6>Individual: ₦{{ toPremium(plan.premiums, 'i') }}</h6>
                          <h6>Family: ₦{{ toPremium(plan.premiums, 'f') }}</h6>

                          <p>
                            (<b>Benefits</b>) {{ benefitCount(plan) }} line items defined

                            <i class="material-icons clickable" :class="{
                              'red-text': showBenefit == plan.id,
                              'teal-text': !(showBenefit == plan.id)
                            }" title="view all" @click="showBenefits(plan)">
                              {{ showBenefit == plan.id ? "cancel" : "visibility" }}
                            </i>
                          </p>
                        </div>

                        <div class="col s2">

                          <div class="right">
                            <a class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2">
                              <i class="material-icons" title="edit plan" @click="handleEdit(plan)">
                                edit
                              </i>
                            </a>
                          </div>

                          <p><br></p>

                          <div class="right" v-if="schemeType(plan) === 'p'">
                            <a class="btn-floating btn-medium waves-effect waves-light" :class="{
                              'red lighten-2': plan.status == 'a',
                              'green lighten-2': plan.status == 's'
                            }">

                              <i class="material-icons" :title="plan.status == 'a' ? 'suspend plan' : 'activate plan'"
                                @click="handleStatus(plan)">
                                {{
                                  plan.status == "a"
                                    ? "pause_circle_outline"
                                    : "play_circle_filled"
                                }}
                              </i>

                            </a>
                          </div>

                        </div>

                      </div>

                      <div class="row" v-if="showBenefit == plan.id">

                        <div class="divider"></div>
                        <br>

                        <span v-for="(benefit, y) in plan.benefits || []" :key="benefit.id">

                          <template v-if="y < 10">

                            <div class="col s1"><br></div>

                            <div class="col s4">
                              {{ y + 1 }}. {{ benefit.item }}
                            </div>

                            <div class="col s7">
                              {{ benefit.description }}
                            </div>

                          </template>

                          <template v-if="y == 10">

                            <div class="col s1"><br></div>
                            <div class="col s4">Others...</div>
                            <div class="col s7"><br></div>

                          </template>

                        </span>

                        <i class="material-icons secondary-content chip clickable" :class="{
                          'red-text': showBenefit == plan.id,
                          'teal-text': !(showBenefit == plan.id)
                        }" title="close" @click="showBenefits(plan)">

                          {{ showBenefit == plan.id ? "clear" : "visibility" }}

                        </i>

                      </div>

                    </div>

                  </div>
                </div>

                <!-- Empty -->
                <div v-if="!plans.length">
                  <span class="chip">No Plan added</span>
                </div>
              </template>
            </template>

            <template v-else>
              <div class="section">
                <div class="card grey lighten-4">
                  <!-- Heading -->
                  <div class="card-content">
                    <span class="card-title teal-text">Add Shelf Policy<i class="material-icons right"
                        v-if="plans.length">check_circle</i></span>
                  </div>

                  <!-- Register Policy -->
                  <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text">Policy Name</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12" :class="{ 'red lighten-5': error && !policyName }">
                        <div class="input-field">
                          <input type="text" id="policyName" v-model="policyName" />
                          <label for="policyName">Policy</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Premium -->
                  <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text">Premiums</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s1"><span class="chip">₦</span></div>
                      <div class="col s4" :class="{
                        'red lighten-5': error && !premiumIndividual,
                      }">
                        <div class="input-field">
                          <input type="number" id="premiumIndividual" v-model="premiumIndividual" class="validate"
                            required />
                          <label class="active" for="premiumIndividual">Premium (Individual)</label>
                        </div>
                      </div>

                      <div class="col s1"></div>

                      <div class="col s1"><span class="chip">₦</span></div>
                      <div class="col s4">
                        <div class="input-field">
                          <input type="number" id="premiumFamily" v-model="premiumFamily" class="validate" />
                          <label class="active" for="premiumFamily">Premium (Family)</label>
                        </div>
                      </div>

                      <div class="col s1"></div>
                    </div>
                  </div>

                  <!-- Benefits -->
                  <div class="card-panel teal-text">
                    <div class="row">
                      <div class="col s12">
                        <span class="black-text">Plan</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col s12" :class="{
                        'red lighten-5': error && !file,
                      }">
                        <div class="file-field input-field">
                          <div class="btn" :class="{ disabled: isSubmitting }">
                            <span>Benefits</span>
                            <input type="file" @change="handleFile" />
                          </div>
                          <div class="file-path-wrapper">
                            <input class="file-path" v-model="inputFile" type="text" />
                            <p class="red-text" v-if="fileError">
                              {{ fileError }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="section center">
                <p>
                  <a class="waves-effect waves-light btn-large grey" :class="{
                    disabled: isSubmitting,
                  }" @click="handleBack">
                    <i class="material-icons left">chevron_left</i>Back
                  </a>
                  <button class="waves-effect waves-light btn-large black" :class="{
                    disabled: isSubmitting,
                  }" @click="handleAdd">
                    <i class="material-icons left">add</i>
                    {{ isSubmitting ? `Adding (${uploadProgress})` : "Add" }}
                  </button>
                </p>
              </div>
            </template>

            <template v-if="!next && !editPolicy">
              <div class="section center">
                <div class="row">
                  <p>
                    <br /><br />
                    <button class="waves-effect waves-light btn-large col s12 m3 right" @click="handleNext">
                      <i class="material-icons left">call_made</i>Next
                    </button>
                  </p>
                  <!-- Spacer -->
                  <span class="col m9"></span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

    </div>
  </template>
</template>

<script>
import { ref, computed, watchEffect, onMounted } from "vue";
import { changeToMoney } from "@/composables/fxLibrary/coreFx";
import getItems from "@/composables/getItems";
// import postItem from "@/composables/postItem";
import useStorage from "@/composables/useStorage";
import putItem from "@/composables/putItem";
import PolicyEditDiv from "@/components/client/onboard/PolicyEditOnboardComponent.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import { adminAPI } from '@/laravel/config';

export default {
  name: "PlanSetupComponent",
  components: { PolicyEditDiv, LoadingDiv },
  emits: ["next"],
  setup(props, context) {
    const response = ref(null);
    const file = ref(null);
    const inputFile = ref(null);
    const fileError = ref(null);
    const isReady = ref(false);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const error = ref(null);
    const next = ref(false);
    const policy = ref([]);
    const policyName = ref(null);
    const premiumIndividual = ref(null);
    const premiumFamily = ref(null);
    const showBenefit = ref(null);
    const editPolicy = ref(null);
    const types = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    // storage
    const { uploadFile, uploadProgress, uploadError, data, completed } =
      useStorage();

    // toMoney
    const toMoney = (val) => {
      const { fx } = changeToMoney(val);
      return fx.value;
    };

    const getPremium = (premiums, type) => {
      if (!premiums || !premiums.length) {
        return null;
      }

      return premiums.find((x) => x.type === type) || null;
    };

    // to premium
    const toPremium = (premiums, type) => {
      const selectedPremium = getPremium(premiums, type);

      if (!selectedPremium || selectedPremium.amount === null || selectedPremium.amount === undefined) {
        return "Not set";
      }

      return toMoney(selectedPremium.amount);
    }

    const schemeType = (plan) => {
      return plan && plan.scheme ? plan.scheme.type : null;
    };

    const benefitCount = (plan) => {
      return plan && plan.benefits ? plan.benefits.length : 0;
    };

    // show benefits
    const showBenefits = (val) => {
      if (val.id != showBenefit.value) {
        showBenefit.value = val.id;
      } else {
        showBenefit.value = null;
      }
    };

    // start
    onMounted(() => {
      // get items
      loadPlans();
    });

    // handle plans loader
    const loadPlans = () => {
      // loasder on
      isReady.value = false;
      // start
      (async () => {
        const { res, err } = await getItems("plan/setup");

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
      })();
    }

    // edit policy
    const handleEdit = (val) => {
      if (val) {
        // sort
        let newVal = { ...val };
        const individualPremium = getPremium(val.premiums, "i");
        const familyPremium = getPremium(val.premiums, "f");
        newVal.premiumIndividual = individualPremium ? individualPremium.amount : 0;
        newVal.premiumFamily = familyPremium ? familyPremium.amount : 0;
        // load
        editPolicy.value = newVal;
      }
    };

    // edit status
    const handleStatus = async (val) => {

      // only private plans can be suspended here
      if (schemeType(val) === 'p') {

        // start
        isLoading.value = true;

        // value
        let newStatus;
        let planId = val.id;

        // new status
        if (val.status == "a") {
          newStatus = "s"; // update status
        } else if (val.status == "s") {
          newStatus = "a"; // update status
        }

        // update
        let newVal = {
          status: newStatus,
        };

        // post item
        const { res, err } = await putItem("plan", planId, newVal);

        if (res.value) {
          // reload plans
          loadPlans();
        } else {
          error.value = err.value;
        }

        // end
        isLoading.value = false;

      }

    };

    // handle update complete
    const handleUpdateComplete = (val) => {
      // release
      editPolicy.value = null;

      if (val.complete) {
        loadPlans();
      }
    };

    // handle add
    const handleReset = () => {
      // clear files
      file.value = null; //clear file value
      inputFile.value = null; // Clear the file input value
      uploadProgress.value = "0%";
      uploadError.value = null;
      data.value = null;
      completed.value = null;
      // null all
      policyName.value = null;
      premiumIndividual.value = null;
      premiumFamily.value = null;
      // next
      next.value = false;
      // clear error
      error.value = false;
      // clear loading
      isLoading.value = false;
      // clear submitting
      isSubmitting.value = false;
      // isReady ???
    };

    const handleBack = () => {
      // restart
      handleReset();
    };

    const handleFile = (e) => {
      const selected = e.target.files[0];
      if (selected && types.includes(selected.type)) {
        file.value = selected;
        inputFile.value = file.value.name;
        fileError.value = null;
      } else {
        file.value = null;
        inputFile.value = null;
        fileError.value = "Please select an Excel file (.XLSX, XLS)";
      }
    };

    // handle add
    const handleAdd = async () => {
      if (
        policyName.value &&
        premiumIndividual.value &&
        file.value  //  && premiumFamily.value not necessary
      ) {
        // set family 
        if (!premiumFamily.value) {
          premiumFamily.value = "0.00";
        }
        // Benefits
        // Start Uploading
        isSubmitting.value = true;

        //start
        uploadError.value = null;

        // Cloud Function
        const fx = "planLoader";

        // setup
        // new plan
        const plan = {
          scheme_id: null, // update this
          name: policyName.value,
          description: "Standard Shelf Plan",
        };

        // individual premium
        const individual = {
          plan_id: null, // update this on server
          amount: premiumIndividual.value,
          type: "i",
        };

        // family premium
        const family = {
          plan_id: null, // update this on server
          amount: premiumFamily.value,
          type: "f",
        };

        // scope
        const scope = 0; // default

        // Start Uploading
        // uploadProgress.value = "100%";

        // round up,
        const cloudInput = {
          plan: plan,
          individual: individual,
          family: family,
          scope: scope,
          action: "new",
          endPoint: `${adminAPI}/plan/benefits/bulk`,
        };

        // // upload
        uploadFile(file.value, fx, cloudInput);
      } else {
        error.value = true;
      }
    };

    // watch upload
    watchEffect(() => {
      if (completed.value) {
        // clear
        handleReset();
        // success
        // handleSuccess(data.value.succ.inserted_rows);
        handleSuccess();
      }
      if (uploadError.value) {
        // restart
        // handleReset();
        // stop
        error.value = uploadError.value;
        isSubmitting.value = false;
      }
    });

    // handle success
    const handleSuccess = () => {
      // update
      loadPlans();
    };

    // handle remove
    const handleRemove = (val) => {
      // filter delete
      policy.value = policy.value.filter((x) => x.id != val);
      // clean up
      handleReset();
    };

    // handle submit
    const handleNext = () => {
      // next
      // emit new parameters
      context.emit("next", {
        step: 3,
        isComplete: true,
      });
    };

    // output results (plans)
    const plans = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    return {
      isReady,
      isLoading,
      isSubmitting,
      error,
      handleStatus,
      handleEdit,
      handleNext,
      handleFile,
      handleAdd,
      handleBack,
      handleRemove,
      handleUpdateComplete,
      showBenefits,
      schemeType,
      benefitCount,
      toPremium,
      toMoney,
      showBenefit,
      editPolicy,
      uploadProgress,
      fileError,
      uploadError,
      file,
      inputFile,
      next,
      policyName,
      premiumIndividual,
      premiumFamily,
      plans,
    };
  },
};
</script>

<style scoped>
.grey-bg-custom {
  background-color: #f2f2f2;
}

.hover-text,
.clickable {
  cursor: pointer;
}

.section .header {
  align-items: center;
  background: #fbfcfc;
  border: 1px solid #d3dde1;
  border-radius: 6px;
  color: #263238;
  display: flex;
  font-size: 1.34rem;
  font-weight: 500;
  justify-content: space-between;
  letter-spacing: 0;
  margin: 0 0 18px;
  padding: 22px 24px;
}

.section .header b {
  font-weight: 800;
}

.section .header :deep(.btn-floating),
.section .header .btn-floating {
  align-items: center;
  border-radius: 6px;
  box-shadow: none;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.plans-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
}

.plans-row > .col {
  display: flex;
  margin-bottom: 18px;
}

.plans-row .card-panel {
  background: #ffffff !important;
  border: 1px solid #d3dde1;
  border-radius: 6px;
  box-shadow: none !important;
  overflow: hidden;
  padding: 0;
  width: 100%;
}

.plans-row .card-panel > .row:first-child {
  align-items: flex-start;
  background: #fbfcfc !important;
  display: flex;
  margin: 0;
  min-height: 100%;
  padding: 20px 18px;
}

.plans-row .card-panel > .row:first-child.yellow.lighten-2 {
  background: #fffdf4 !important;
}

.plans-row h5 {
  color: #263238;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.25;
  margin: 0 0 12px;
}

.plans-row h6 {
  color: #263238;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.55;
  margin: 4px 0;
}

.plans-row p {
  color: #607d8b;
  line-height: 1.55;
  margin: 10px 0;
}

.plans-row .chip {
  border-radius: 999px;
  box-shadow: none;
  font-weight: 800;
}

.plans-row .btn-floating {
  align-items: center;
  border-radius: 6px;
  box-shadow: none !important;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  margin-bottom: 8px;
  width: 38px;
}

.plans-row .btn-floating i {
  line-height: 38px;
}

.plans-row .secondary-content.chip {
  background: #ffffff;
  border: 1px solid #d3dde1;
  box-shadow: none;
}

.plans-row .card-panel > .row:nth-child(2) {
  background: #ffffff;
  border-top: 1px solid #edf1f3;
  margin: 0;
  padding: 18px;
}

.card.grey.lighten-4,
.card-panel {
  box-shadow: none !important;
}

@media only screen and (max-width: 992px) {
  .section .header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
}

@media only screen and (max-width: 600px) {
  .section .header {
    font-size: 1.2rem;
    padding: 18px;
  }

  .section .header :deep(.btn-floating),
  .section .header .btn-floating {
    width: 100%;
  }

  .plans-row {
    margin-left: 0;
    margin-right: 0;
  }

  .plans-row > .col {
    padding-left: 0;
    padding-right: 0;
  }

  .plans-row .card-panel > .row:first-child,
  .plans-row .card-panel > .row:nth-child(2) {
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .plans-row .card-panel .col {
    padding-left: 0;
    padding-right: 0;
    width: 100% !important;
  }

  .plans-row .btn-floating,
  .plans-row .secondary-content.chip {
    float: none !important;
    width: 100%;
  }

  .card.grey.lighten-4 .card-content,
  .card-panel {
    padding: 16px;
  }

  .btn-large,
  button.btn-large,
  a.btn-large {
    width: 100%;
  }
}
</style>
